import React from "react";

const UkFlag = ({ style = { height: "2vh", width: "2vh" } }) => {
  return (
    <svg
      clip-rule="evenodd"
      fill-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="1.414"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g id="GREAT-BRITAIN" transform="translate(-410 -775)">
        <g transform="translate(410 775)">
          <path
            d="m11.675 418.34c-3.687-11.793-5.675-24.336-5.675-37.34v-36.111h.299v-177.778h.299v-36.111c0-60.309 42.751-110.7 99.543-122.425l.767-.156c7.935-1.587 16.141-2.419 24.54-2.419h249.701c55.713.001 102.951 36.614 118.999 87.099l.177.561c3.687 11.793 5.675 24.336 5.675 37.34v36.111h-.299v177.778h-.299v36.111c0 68.986-55.938 124.995-124.85 125h-249.701c-8.459 0-16.722-.844-24.71-2.453l-.669-.136c-44.318-9.177-80.076-41.904-93.62-84.51z"
            fill="#01338e"
          />
        </g>
        <g transform="translate(410 775)">
          <path
            d="m310.514 175.199 174.753-113.167c2.323 3.507 4.474 7.137 6.441 10.878l-175.967 113.55h48.023l137.719-88.869c2.944 10.636 4.517 21.84 4.517 33.409v10.21l-69.875 45.25h69.576v28.235h-195.187v83.285h195.187v27.828h-70.036l69.737 45.16v10.032c0 1.926-.043 3.842-.13 5.746l-94.436-60.938h-47.662l137.649 88.824c-3.556 12.757-9.085 24.694-16.237 35.46l-174.072-112.725v168.633h-107.974v-168.275l-175.056 113.363c-2.487-3.668-4.785-7.474-6.879-11.406l176.47-113.874h-48.022l-138.348 89.274c-3.065-10.836-4.705-22.269-4.705-34.082v-8.604l71.942-46.588h-71.643v-27.828h196.241v-83.285h-196.241v-28.235h71.183l-70.884-45.903v-9.557c0-1.7.034-3.393.101-5.077l93.814 60.537h47.667l-137.164-88.51c3.586-13.108 9.251-25.359 16.618-36.374l174.906 113.265v-168.841h107.974z"
            fill="#fff"
          />
        </g>
        <g transform="matrix(1 0 0 1.000262 410 774.789388)">
          <g>
            <path
              d="m224.36 6h64.333v208.695h217.008v83.285h-217.008v208.02h-64.333v-208.02h-218.061v-83.285h218.061z"
              fill="#de2e39"
            />
          </g>
          <g>
            <g>
              <path
                d="m11.016 97.95 137.164 88.51h-47.667l-93.814-60.537c.386-9.645 1.865-19.009 4.317-27.973z"
                fill="#de2e39"
              />
            </g>
            <g>
              <path
                d="m505.272 386.746c-.435 9.617-1.958 18.953-4.449 27.886l-137.649-88.824h47.662z"
                fill="#de2e39"
              />
            </g>
            <g>
              <path
                d="m491.708 72.91c3.376 6.421 6.209 13.171 8.44 20.189l.177.561c.407 1.301.793 2.612 1.158 3.931l-137.719 88.869h-48.023z"
                fill="#de2e39"
              />
            </g>
            <g>
              <path
                d="m20.605 439.682c-3.513-6.597-6.453-13.547-8.753-20.781l-.177-.561c-.337-1.08-.661-2.166-.97-3.258l138.348-89.274h48.022z"
                fill="#de2e39"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default UkFlag;
